export const LONG_LASTING_COOKIE_EXPIRATION = 365 * 10
